export { default } from "./control-panel";
